
import { Component, Prop, Vue } from 'vue-property-decorator';
import { repositories } from '@/api/ApiFactory';
import ErrorHandler from '@/components/shared/errorHandler';
import { Tag as ITag } from '@/api/interfaces';

@Component
export default class Tag extends Vue {
  @Prop() private tag!: ITag;
  @Prop({ default: true }) private showToolbar!: boolean;
  @Prop({ default: false }) private showControls!: boolean;

  private async deleteTag(modal: any, tag: ITag) {
    try {
      await repositories.core.tag.delete(tag.slug!);
      this.$emit('deleted', tag);
      this.$modals.close();
    } catch (error) {
      this.$toasted.error(
        new ErrorHandler(
          { error, status: true },
          { itemMessageText: 'značkah' },
        ).toString(),
      );
      modal.deleting = false;
    }
  }

  private removeTag(tag: ITag) {
    this.$modals.open('app-confirm-delete', {
      component: {
        props: {
          data: {
            repr: `značko ${tag.name}`,
            item: tag,
          },
          deleteFn: this.deleteTag,
        },
      },
      dialog: {
        props: {
          'max-width': '600px',
        },
      },
    });
  }

  private editTag(tag: ITag) {
    this.openAddOrEditTagModal(tag);
  }

  private openAddOrEditTagModal(tag: ITag | null = null) {
    const promise: Promise<ITag> = this.$modals.open(
      'app-add-or-edit-tag-modal',
      {
        component: {
          props: {
            data: tag,
          },
        },
        dialog: {
          props: {
            'max-width': '600px',
          },
        },
      },
    ) as Promise<ITag>;
    promise.then((innerTag: ITag) => {
      this.$emit('updated', innerTag);
    });
  }
}
